/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipAltReportExportStatusQueryResponse, AuditReportsGetGipAltReportExportStatusPathParams, AuditReportsGetGipAltReportExportStatus401, AuditReportsGetGipAltReportExportStatus403, AuditReportsGetGipAltReportExportStatus404 } from "../models/AuditReportsGetGipAltReportExportStatus";

export function getAuditReportsGetGipAltReportExportStatusUrl(id: AuditReportsGetGipAltReportExportStatusPathParams["id"]) {
  const res = { method: 'GET', url: `/audit-reports/v1/reports/gip-alt/report/${id}/export-status` as const }
  return res
}

/**
 * @summary Get export job status for report
 * {@link /audit-reports/v1/reports/gip-alt/report/:id/export-status}
 */
export async function auditReportsGetGipAltReportExportStatus(id: AuditReportsGetGipAltReportExportStatusPathParams["id"], config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<AuditReportsGetGipAltReportExportStatusQueryResponse, ResponseErrorConfig<AuditReportsGetGipAltReportExportStatus401 | AuditReportsGetGipAltReportExportStatus403 | AuditReportsGetGipAltReportExportStatus404>, unknown>({ method : "GET", url : getAuditReportsGetGipAltReportExportStatusUrl(id).url.toString(), ... requestConfig })
  return res.data
}